import './CountText.svelte.css';
/* src/components/CountText.svelte generated by Svelte v3.37.0 */
import {
	SvelteComponent,
	append,
	attr,
	detach,
	element,
	empty,
	init,
	insert,
	noop,
	safe_not_equal,
	set_data,
	text
} from "../../_snowpack/pkg/svelte/internal.js";

import { getCategoryCountText, getThingCountTextFromLength } from "../utils/str.js";

function create_else_block(ctx) {
	let p;
	let t_value = getThingCountTextFromLength(/*count*/ ctx[1]) + "";
	let t;

	return {
		c() {
			p = element("p");
			t = text(t_value);
			attr(p, "class", "jd-count jd-count--show-on-focus svelte-fseupq");
		},
		m(target, anchor) {
			insert(target, p, anchor);
			append(p, t);
		},
		p(ctx, dirty) {
			if (dirty & /*count*/ 2 && t_value !== (t_value = getThingCountTextFromLength(/*count*/ ctx[1]) + "")) set_data(t, t_value);
		},
		d(detaching) {
			if (detaching) detach(p);
		}
	};
}

// (7:0) {#if countType === "CATEGORY"}
function create_if_block(ctx) {
	let p;
	let t_value = getCategoryCountText(/*items*/ ctx[0]) + "";
	let t;

	return {
		c() {
			p = element("p");
			t = text(t_value);
			attr(p, "class", "jd-count jd-count--show-on-focus svelte-fseupq");
		},
		m(target, anchor) {
			insert(target, p, anchor);
			append(p, t);
		},
		p(ctx, dirty) {
			if (dirty & /*items*/ 1 && t_value !== (t_value = getCategoryCountText(/*items*/ ctx[0]) + "")) set_data(t, t_value);
		},
		d(detaching) {
			if (detaching) detach(p);
		}
	};
}

function create_fragment(ctx) {
	let if_block_anchor;

	function select_block_type(ctx, dirty) {
		if (/*countType*/ ctx[2] === "CATEGORY") return create_if_block;
		return create_else_block;
	}

	let current_block_type = select_block_type(ctx, -1);
	let if_block = current_block_type(ctx);

	return {
		c() {
			if_block.c();
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if_block.m(target, anchor);
			insert(target, if_block_anchor, anchor);
		},
		p(ctx, [dirty]) {
			if (current_block_type === (current_block_type = select_block_type(ctx, dirty)) && if_block) {
				if_block.p(ctx, dirty);
			} else {
				if_block.d(1);
				if_block = current_block_type(ctx);

				if (if_block) {
					if_block.c();
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { items = [] } = $$props; // used by category
	let { count = 0 } = $$props; // used by thing
	let { countType = "CATEGORY" } = $$props;

	$$self.$$set = $$props => {
		if ("items" in $$props) $$invalidate(0, items = $$props.items);
		if ("count" in $$props) $$invalidate(1, count = $$props.count);
		if ("countType" in $$props) $$invalidate(2, countType = $$props.countType);
	};

	return [items, count, countType];
}

class CountText extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { items: 0, count: 1, countType: 2 });
	}
}

export default CountText;